import { Avatar, Box, Typography } from '@mui/material';
import { darken, useTheme } from '@mui/material/styles';
import moment from 'moment';
import type { CalendarColorPalette } from 'dashboard409a/common/constants/calendar';
import { CALENDAR_PREVIEW_DATE_FORMAT } from 'dashboard409a/common/constants/calendar';
import { getInitials } from 'utilities/getInitials';

interface CalendarPreviewProps {
  colorPalette: CalendarColorPalette;
}

export const CalendarPreview = ({ colorPalette }: CalendarPreviewProps) => {
  const theme = useTheme();
  const labelsBackgroundColor = colorPalette.LABELS;
  const labelsTextColor = theme.palette.getContrastText(labelsBackgroundColor);
  const textColor = theme.palette.getContrastText(colorPalette.DRAFT);

  return (
    <Box
      sx={{
        width: '190px',
        minHeight: '90px',
        display: 'flex',
        flexDirection: 'column',
        padding: 0.5,
        backgroundColor: colorPalette.BACKGROUND,
        border: `1px solid ${colorPalette.BORDER}`,
        borderRadius: 1,
        margin: '0 auto'
      }}
    >
      <Box
        sx={{
          backgroundColor: colorPalette.DRAFT,
          padding: 0.5,
          borderRadius: 1,
          width: 50,
          height: 10,
          mb: 0.5,
        }}
      />
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography
          variant="caption"
          fontWeight="bold"
          sx={{
            lineHeight: 1.2,
            color: theme.palette.getContrastText(colorPalette.BACKGROUND),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
            Dunder Mifflin, Inc
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{ padding: 0.5, borderRadius: 1, flexWrap: 'wrap', gap: 0.5 }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          sx={{
            color: labelsTextColor,
            backgroundColor: labelsBackgroundColor,
            padding: 0.5,
            borderRadius: 1,
          }}
        >
          <Typography variant="caption" fontSize="0.7rem" sx={{ color: labelsTextColor }}>
              Consulting
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          sx={{
            backgroundColor: labelsBackgroundColor,
            padding: 0.5,
            borderRadius: 1,
          }}
        >
          <Typography variant="caption" fontSize="0.7rem" sx={{ color: labelsTextColor }}>
            {moment().format(CALENDAR_PREVIEW_DATE_FORMAT)}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="space-between" sx={{ mt: 0.5 }}>
        <Avatar sx={{ width: 20, height: 20, fontSize: '0.75rem', bgcolor: darken(labelsBackgroundColor, 0.2) }}>
          {getInitials({ name: 'John Rambo' })}
        </Avatar>
        <Avatar sx={{ width: 20, height: 20, fontSize: '0.75rem', bgcolor: darken(labelsBackgroundColor, 0.2) }}>
          {getInitials({ name: 'Sylvester Stallone' })}
        </Avatar>
      </Box>
    </Box>
  );
};